<span class="component-container base-data-container">
	<form [formGroup]="infoOnConstructionFG"
        class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-section form-font-size">
		<div class="form-background">
			<div *ngFor="let chimney of constructionChimney"
           class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-rows">
				<div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
					<p-radioButton [label]="(getSkChimSweepLabel(chimney.value) | translate)" [value]="chimney.value.trim()"
                         class="p-field-radio"
                         formControlName="constructionChimneySweep" labelStyleClass="radio-label"
                         name="construction_chimney"></p-radioButton>
				</div>
			</div>
		</div>
	</form>
</span>
